import { render, staticRenderFns } from "./BuffetPlanPicker.vue?vue&type=template&id=0e9e0ba4&scoped=true&"
import script from "./BuffetPlanPicker.vue?vue&type=script&lang=js&"
export * from "./BuffetPlanPicker.vue?vue&type=script&lang=js&"
import style0 from "./BuffetPlanPicker.vue?vue&type=style&index=0&id=0e9e0ba4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9e0ba4",
  null
  
)

export default component.exports